import { render } from "./AdminNieuws.vue?vue&type=template&id=3d43fa60"
import script from "./AdminNieuws.vue?vue&type=script&lang=js"
export * from "./AdminNieuws.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__